<template>
  <div class="ticket-attachments">
    <h3 v-if="title" class="mb-2">{{ title }}</h3>
    <span v-if="subtitle">
      {{ subtitle }}
    </span>
    <h5 v-if="multiple" class="mt-3">
      تعداد کل: {{ attachments.length + " / " + maxAttachments }}
    </h5>
    <vs-row class="mb-0 mt-4">
      <vs-col
        v-for="(attachment, index) in attachments"
        :key="attachment.id"
        vs-xs="12"
        vs-sm="12"
        vs-lg="9"
        style="margin-bottom: 10px"
        class="flex items-center"
      >
        <div class="order">{{ index + 1 }}</div>
        <input
          :id="`button-${attachment.id}`"
          :name="`button-${attachment.id}`"
          :accept="accept"
          type="file"
          @input="(output) => handleSelectFile(output, index)"
          style="display: none"
          v-on:click="(event) => handleClickFile(event, attachment)"
        />
        <label :for="`button-${attachment.id}`" class="flex-1">
          <div class="upload-file-wrapper">
            <p v-if="!attachment.file && !attachment.url" class="select-file">
              {{ "+ انتخاب" }}
            </p>
            <div class="divider" />

            <img v-if="attachment.url" :src="attachment.url" />
            <div class="file-wrapper px-2">
              <p v-if="!attachment.isFromServer">
                {{
                  attachment.file
                    ? attachment.file.name
                    : "هنوز هیچ فایلی انتخاب نشده است."
                }}
              </p>
            </div>
            <div class="buttons px-2">
              <vs-button
                v-if="attachment.url"
                @click="toggleImagePreview(attachment.url)"
                class="mr-1"
                color="primary"
                type="filled"
                size="small"
                icon-pack="feather"
                icon="icon-eye"
              />
              <vs-button
                @click="deleteAttachment(attachment)"
                class="ml-1"
                color="danger"
                type="filled"
                size="small"
                icon-pack="feather"
                icon="icon-trash"
              />
            </div>
          </div>
        </label>
      </vs-col>
      <vs-col
        v-if="
          (multiple || attachments.length < 1) &&
          attachments.length < maxAttachments
        "
        vs-xs="12"
        vs-sm="12"
        vs-lg="3"
        class="mb-0"
      >
        <vs-button @click="addAttachment" class="mt-1 px-4">
          افزودن {{ accept.includes("image") ? "تصویر" : "فایل" }}
        </vs-button>
      </vs-col>
    </vs-row>

    <vs-popup title="برش عکس" :active.sync="cropPopupVisible">
      <cropper
        :imageBase64="imageBase64"
        :cropPopupVisible="cropPopupVisible"
        :aspectRatio="aspectRatio"
        :fileType="fileType"
        @cropImage="cropImage"
      />
    </vs-popup>

    <image-preview ref="imagePreviewRef" :image="selectedImageForPreview" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import {
  convertBlobToFile,
  generateRandomNumber,
} from "../../../helpers/Functions";
import Cropper from "../../../components/image/Cropper.vue";
import ImagePreview from "../../../components/image/ImagePreview";
import providerApiService from "../../../services/api/ProviderApiService";
import heic2any from "heic2any";

export default {
  name: "Attachments.vue",
  components: { Cropper, ImagePreview },
  data() {
    return {
      attachments: this.initialAttachments(),
      selectedIndex: 0,
      imageBase64: "",
      fileType: "",
      cropPopupVisible: false,
      selectedImageForPreview: "",
      maxAttachments: 10,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  props: {
    data: {
      type: Array,
      required: false,
    },
    aspectRatio: {
      type: Number,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
    accept: {
      type: String,
      required: false,
      default: "file/*",
    },
    urlForDelete: {
      type: String,
      required: false,
    },
  },
  methods: {
    initialAttachments() {
      if (Array.isArray(this.data) && this.data.length > 0) {
        return this.data.map((element) => ({
          id: element.id,
          url: element.url,
          isFromServer: true,
        }));
      }

      return [{ id: generateRandomNumber() }];
    },
    getData() {
      const list = this.attachments
        .filter((item) => item.file)
        .map((element) => element.file);
      return list;
    },
    cropImage(blob) {
      this.cropPopupVisible = false;
      this.imageSource = "";
      const file = convertBlobToFile(blob);
      this.modifyAttachment(file);
    },
    handleSelectFile(event, index) {
      const file = event.target.files[0];

      this.selectedIndex = index;

      const lastDot = file.name.lastIndexOf(".");
      const ext = file.name.substring(lastDot + 1);

      this.cropPopupVisible = true;

      if (ext.toLowerCase().includes("heic")) {
        heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.5, // cuts the quality and size by half
        })
          .then(this.selectFile)
          .catch(() => {
            this.$vs.notify({
              text: "خطا در بارگذاری فایل. لطفا مجدد تلاش کنید.",
              color: "danger",
              position: "bottom-center",
            });
          });
      } else {
        this.selectFile(file);
      }
    },
    selectFile(file) {
      this.fileType = file.type;

      if (this.fileType.includes("image")) {
        this.imageBase64 = URL.createObjectURL(file); // Base64
      } else {
        this.modifyAttachment(file);
      }
    },
    modifyAttachment(file) {
      if (file) {
        let newAttachments = [...this.attachments]; // Clone all the attachments
        /**
         * Find attachment index for modifying
         */
        const attachmentIndex = newAttachments.findIndex(
          (_el, i) => i === this.selectedIndex
        );
        /**
         * Modify the file of the attachment if it exists
         */
        if (attachmentIndex >= 0) {
          newAttachments[attachmentIndex].file = file;
          if (this.fileType.includes("image")) {
            newAttachments[attachmentIndex].url = URL.createObjectURL(file);
          }
        }
        this.attachments = newAttachments;
      }
    },
    addAttachment() {
      this.attachments.push({ id: generateRandomNumber() });
    },
    deleteAttachment(attachment) {
      if (!attachment.file && attachment.url) {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: `حذف عکس`,
          text: `از حذف عکس اطمینان دارید؟`,
          acceptText: "بلی",
          cancelText: "خیر",
          accept: () => {
            this.requestToDeleteAttachment(attachment);
          },
        });
      } else {
        this.deleteAttachmentFromClient(attachment);
      }
    },
    requestToDeleteAttachment(attachment) {
      this.$vs.loading();

      providerApiService
        .deleteAttachment(
          this.urlForDelete,
          this.currentProvider.id,
          attachment.id
        )
        .then(() => {
          this.deleteAttachmentFromClient(attachment);
          this.$vs.notify({
            text: "عملیات با موفقیت انجام شد.",
            color: "success",
            position: "bottom-center",
          });
        })
        .catch(() =>
          this.$vs.notify({
            text: "عملیات با خطا مواجه شد.",
            color: "danger",
            position: "bottom-center",
          })
        )
        .finally(() => this.$vs.loading.close());
    },
    deleteAttachmentFromClient(attachment) {
      const newAttachments = this.attachments.filter(
        (element) => element.id !== attachment.id
      );
      this.attachments = newAttachments;
    },
    toggleImagePreview(url) {
      this.$refs.imagePreviewRef.togglePreviewVisibility();
      this.selectedImageForPreview = url;
    },
    handleClickFile(event, attachment) {
      if (attachment.isFromServer) {
        event.preventDefault();
        this.$vs.notify({
          text: "برای ویرایش عکس ابتدا آن را حذف کنید. سپس عکس مورد نظر خود را انتخاب کنید.",
          color: "warning",
          position: "bottom-center",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.ticket-attachments {
  flex: 1;

  .order {
    border-radius: 50%;
    background-color: #fafafa;
    width: 25px;
    height: 25px;
    display: grid;
    place-items: center;
    margin-right: 10px;
    font-weight: 500;
  }

  .upload-file-wrapper {
    display: flex;
    border: 1px solid #23232340;
    border-radius: 5px;
    height: 50px;
    cursor: pointer;
    overflow: hidden;

    .select-file {
      display: flex;
      align-items: center;
      padding: 0 8px;
      background-color: rgba(var(--vs-primary), 1);
      color: #fff;
    }

    img {
      width: 40px;
      border-radius: 5px;
      margin: 5px;
      margin-right: 0;
      object-fit: contain;
      object-position: center;
    }

    .divider {
      border-right: 1px solid #23232340;
    }

    .file-wrapper {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .buttons {
      display: flex;
      align-items: center;
      height: 100%;
    }
  }
}
</style>

